import React from 'react'
import PropTypes from 'prop-types'

const PrestationNumberFilter = ({ value, handleChange }) => {
  return (
    <input
      type="text"
      className="form-control"
      placeholder="Numéro de livraison (ex: P2)"
      value={value}
      onChange={handleChange}
      style={{ minWidth: '200px' }}
    />
  )
}

PrestationNumberFilter.propTypes = {
  value: PropTypes.string,
  handleChange: PropTypes.func,
}

PrestationNumberFilter.defaultProps = {
  value: '',
  handleChange: () => {},
}

export default PrestationNumberFilter
